import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';

interface StyledIconProps {
  $backgroundColor?: string;
  $size?: number;
}

const StyledIcon = styled.div<StyledIconProps>`
  border-radius: 50%;
  background-clip: padding-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  background-color: ${({ $backgroundColor }) => $backgroundColor || 'inherit'};
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
`;

interface CircleIconProps {
  backgroundColor?: string;
  name?: string;
  size?: number;
  fillColor?: string;
  className?: string;
  [key: string]: unknown;
}

const CircleIcon = ({ backgroundColor, name, size, fillColor, className, ...restProps }: CircleIconProps) => {
  const circleSize = size || 48;
  const svgSize = size || 30;

  return (
    <StyledIcon $backgroundColor={backgroundColor} $size={circleSize} className={className} data-testid="CircleIcon">
      <Icon name={name} cdn width={svgSize} height={svgSize} fillColor={fillColor} {...restProps} />
    </StyledIcon>
  );
};

export { CircleIcon };
